import { Component, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-soap-page',
  standalone: true,
  imports: [RouterLink, FormsModule],
  templateUrl: './soap-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './soap-page.component.scss'
})
export class SoapPageComponent {

  // Scorrendo, la barra sale a filo del bordo (top 0): lo spazio sopra di lei
  // mostrava il contenuto che passava. Stessa logica della home.
  scrolled = false;

  @HostListener('window:scroll')
  onScroll(): void {
    this.scrolled = window.scrollY > 8;
  }

  // Lo schema del decoder sta qui e non nel template: graffe e chiocciole
  // dentro un template Angular verrebbero interpretate come sintassi.
  readonly mtomSnippet =
`// Il SoapServer di PHP non gestisce multipart/related (MTOM):
// il body si legge a blocchi e in RAM resta solo l'envelope XML.
$in = fopen('php://input', 'rb');
while (!feof($in)) {
    $chunk = fread($in, 1024 * 1024);      // 1 MB alla volta
    // riconosce i boundary MIME:
    //  - la parte XML (envelope) resta in memoria
    //  - ogni parte binaria va dritta su un file temporaneo
}
// Ogni <xop:Include href="cid:..."/> diventa un riferimento al file:
// il servizio riceve un percorso, non 150 MB di base64 in un nodo XML.`;

  contactName    = '';
  contactEmail   = '';
  contactPhone   = '';
  contactMsg     = '';
  contactSending = false;
  contactStatus: 'idle' | 'ok' | 'error' = 'idle';

  private contactOpenedAt = Math.floor(Date.now() / 1000);

  constructor(private http: HttpClient) {}

  sendContact(e: Event): void {
    e.preventDefault();
    if (!this.contactName.trim() || !this.contactEmail.trim() || !this.contactMsg.trim() || this.contactSending) return;

    this.contactSending = true;
    this.contactStatus  = 'idle';

    this.http.post<{ ok: boolean }>('/php/api/contact.api.php', {
      name:    this.contactName.trim(),
      email:   this.contactEmail.trim(),
      phone:   this.contactPhone.trim(),
      message: this.contactMsg.trim(),
      source:  'soap-mtom',
      website: '',
      _t:      this.contactOpenedAt,
    }).subscribe({
      next: () => {
        this.contactStatus   = 'ok';
        this.contactSending  = false;
        this.contactName     = '';
        this.contactEmail    = '';
        this.contactPhone    = '';
        this.contactMsg      = '';
        this.contactOpenedAt = Math.floor(Date.now() / 1000);
      },
      error: () => {
        this.contactStatus  = 'error';
        this.contactSending = false;
      }
    });
  }
}
